import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {
  ProducaoChart,
  PropostasIncorporadasChart,
  ProtocolosChart,
  SolicitacaoImagensChat,
  SolicitacaoImagensSLAChat,
} from '../../../_metronic/partials/widgets'
import {listDashboards} from './core/_requests'

import {GetDashboardResponse} from './core/_models'

import './styles.css'

type Props = {
  data: GetDashboardResponse
}

const DashboardPage: FC<Props> = ({data}) => (
  <>
    {/* begin::Row */}
    <div className='row gy-5 g-xl-8'>
      <div className='col-xxl-6'>
        <ProducaoChart
          className='mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='350px'
          data={data.producao}
        />
        <ProtocolosChart
          className='mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='350px'
          data={data.protocolos}
        />
        {/* <SolicitacaoImagensSLAChat
          className='mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='350px'
          data={data.solicitacaoDeImagens}
        /> */}
      </div>
      <div className='col-xxl-6'>
        <PropostasIncorporadasChart
          className='mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='350px'
          data={data.propostasIncorporadas}
        />
        <SolicitacaoImagensChat
          className='mb-5 mb-xl-8'
          chartColor='primary'
          chartHeight='350px'
          data={data.solicitacaoDeImagens}
        />
      </div>
    </div>
    {/* end::Row */}
  </>
)

const DashboardWrapper = () => {
  const [data, setData] = useState<GetDashboardResponse>({
    producao: {data: [], categories: []},
    protocolos: {series: [], labels: []},
    propostasIncorporadas: {series: [], labels: []},
    solicitacaoDeImagens: {series: [], xaxis: {categories: []}},
  })
  const [dataInicial, setDataInicial] = useState<string>('2021-01-01')
  const [dataFinal, setDataFinal] = useState<string>('2024-03-01')

  const [loading, setLoading] = useState<boolean>(true)

  const intl = useIntl()

  const getDataForDashboards = async () => {
    console.log(dataInicial, dataFinal)

    setLoading(true)
    const response = await listDashboards(dataInicial, dataFinal)
    setData(response)
    setLoading(false)
  }

  useEffect(() => {
    getDataForDashboards()
  }, [])

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <div className='row gy-12 g-xl-12 dashboard-filters'>
        <div className='col-xxl-4'>
          Data inicial:
          <input
            type='date'
            className='form-control mb-3 mb-lg-0'
            onChange={(e) => setDataInicial(e.target.value)}
          />
        </div>
        <div className='col-xxl-4'>
          Data final:
          <input
            type='date'
            className='form-control mb-3 mb-lg-0'
            onChange={(e) => setDataFinal(e.target.value)}
          />
        </div>
        <div className='col-xxl-4'>
          <button type='button' className='btn btn-primary' onClick={getDataForDashboards}>
            Filtrar
          </button>
        </div>
      </div>
      {!loading && <DashboardPage data={data} />}
    </>
  )
}

export {DashboardWrapper}
